<p-table
  #dt
  class="datatable"
  [styleClass]="styleClass"
  [style]="style"
  [columns]="selectedColumns"
  [dataKey]="dataKey"
  [value]="value"
  [totalRecords]="totalRecords"
  [reorderableColumns]="reorderableColumns"
  (onColReorder)="colReordered($event)"
  [resizableColumns]="resizableColumns"
  [columnResizeMode]="columnResizeMode"
  (onColResize)="colResized($event)"
  [lazy]="lazy"
  [loading]="loading"
  [paginatorDropdownAppendTo]="'body'"
  [currentPageReportTemplate]="currentPageReportTemplate"
  [paginator]="paginator"
  [(first)]="first"
  [rows]="rows"
  [rowsPerPageOptions]="rowsPerPageOptions"
  [showCurrentPageReport]="showCurrentPageReport"
  (onPage)="pageEvent($event)"
  [selectionMode]="selectionMode"
  [rowExpandMode]="rowExpandMode"
  (expandableRows)="(expandable)"
  [expandedRowKeys]="expandedRows"
  [(selection)]="selectedRows"
  [rowHover]="rowHover"
  (selectionChange)="selectionChange($event)"
  (onRowSelect)="onRowSelectEvent($event)"
  [scrollable]="scrollable"
  [scrollHeight]="scrollHeight"
  [sortMode]="sortMode"
  (onSort)="sortEvent($event)"
  [editMode]="editMode"
  (onStateSave)="saveTablePreference($event)"
  [tableStyle]="{'table-layout': 'fixed'}"
>
  <ng-template pTemplate="caption" class="flex">
    <p *ngIf="tableTitle">{{ tableTitle }}</p>

    <div class="flex align-items-center">
      <div class="inline-block my-1">
        <laas-table-column-toggle
          *ngIf="toggleable"
          [optionsColumn]="defaultColumns"
          [dataTable]="dt"
          [confirmEmitControl]="true"
          (onToggleConfirm)="colToggled()"
        >
        </laas-table-column-toggle>
      </div>
      <div class="inline-block my-1 flex align-items-center flex-wrap">
        <ng-container *ngIf="isEdit">
          <!-------------------------------------- Add Button ---------------------------------------------->
          <div class="inline-block my-1" *ngIf="isShowCreateRowFunction">
            <button
              *ngIf="isShowCreateRowFunction"
              pButton
              type="button"
              label="{{ 'Common.Button.Add' | translate }}"
              icon="fas fa-plus"
              [disabled]="!isInEditMode"
              class="p-button-success p-button-raised"
              (click)="createRowEvent()"
            ></button>
          </div>
          <!-------------------------------------- Delete Button ---------------------------------------------->
          <div class="inline-block my-1" *ngIf="isShowDeleteFunction">
            <button
              *ngIf="isShowDeleteFunction"
              pButton
              type="button"
              label="{{ 'Common.Button.Delete' | translate }}"
              icon="fas fa-trash-alt"
              [disabled]="!isInEditMode"
              (click)="deleteRowEvent()"
              class="p-button-danger p-button-raised"
            ></button>
          </div>
          <!-------------------------------------- Save Button ---------------------------------------------->
          <div class="inline-block my-1" *ngIf="isShowSaveFunction">
            <button
              *ngIf="isShowSaveFunction"
              pButton
              class="p-button-raised"
              label="{{ 'Common.Button.Save' | translate }}"
              icon="fas fa-save"
              [disabled]="!isInEditMode"
              (click)="saveEvent()"
            ></button>
          </div>
          <!-------------------------------------- Restore Button ---------------------------------------------->
          <div class="inline-block my-1">
            <button
              pButton
              class="p-button-secondary p-button-raised"
              label="{{ 'Common.Button.Restore' | translate }}"
              icon="fas fa-sync-alt"
              [disabled]="!isInEditMode"
              (click)="restoreEvent()"
            ></button>
          </div>
          <!-------------------------------------- Edit Button ---------------------------------------------->
          <div class="inline-block my-1">
            <button
              pButton
              style="color: white"
              class="p-button-warning p-button-raised"
              label="{{
                isInEditMode
                  ? ('Common.Button.Cancel' | translate)
                  : ('Common.Button.Edit' | translate)
              }}"
              icon="fas fa-pen"
              (click)="switchEditModeEvent()"
            ></button>
          </div>
          <div class="inline-block my-1" *ngIf="isShowExportFunction">
            <button
              pButton
              type="button"
              label="{{'Common.Button.Export' | translate}}"
              icon="fas fa-arrow-alt-circle-down"
              class="p-button-info p-button-raised"
              (click)="exportDataEvent()"
            ></button>
          </div>
          <div class="inline-block my-1" *ngIf="isShowImportFunction">
            <input 
              #fileInput 
              type="file" 
              style="display: none;" 
              (change)="onFileSelected($event)"
              accept=".xlsx,.xls,.csv"
            />
            <button
              pButton
              type="button"
              label="{{'Common.Button.Import' | translate}}"
              icon="fas fa-file-import"
              class="p-button-help p-button-raised"
              [disabled]="!isInEditMode"
              (click)="importDataEvent()"
            ></button>
          </div>
        </ng-container>
        <ng-container *ngIf="captionTemplate">
          <ng-container *ngTemplateOutlet="captionTemplate"></ng-container>
        </ng-container>
      </div>
      <div class="flex-1" *ngIf="outerCaptionTemplate">
        <ng-container *ngTemplateOutlet="outerCaptionTemplate"></ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
      <col *ngIf="selectable"/>
      <col *ngIf="expandable"/>
    </colgroup>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <ng-container *ngIf="headerTemplate; else commonHeaderTemplate">
      <ng-container
        *ngTemplateOutlet="headerTemplate; context: { $implicit: columns }"
      ></ng-container>
    </ng-container>
    <ng-template #commonHeaderTemplate>
      <tr>
        <th *ngIf="selectable" scope="col" class="text-center" style="width: 1rem">
          <p-tableHeaderCheckbox />
        </th>
        <th *ngIf="expandable" scope="col" class="text-center" style="width: 1rem"></th>
        <ng-container *ngFor="let col of columns">
          <th
            *ngIf="col.field !== '__delete'; else widthOneColumn"
            scope="col"
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            pReorderableColumn
            pResizableColumn
            [attr.field]="col.field"
          >
            {{ col.header | translate }}
            <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
          </th>
          <ng-template #widthOneColumn>
            <th
              style="width: 1rem"
              scope="col"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              pReorderableColumn
              pResizableColumn
              [attr.field]="col.field"
            >
              {{ col.header | translate }}
              <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
            </th>
          </ng-template>
        </ng-container>
      </tr>
    </ng-template>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-rowIndex="rowIndex"
    let-expanded="expanded"
  >
    <tr
      [pSelectableRow]="rowData"
      [style]="getRowStyle(rowData)"
      [pEditableRow]="rowData"
      (click)="onRowClickEvent(rowData)"
    >
      <td *ngIf="selectable" class="text-center" style="width: 1rem">
        <p-tableCheckbox [pSelectableRow]="rowData" [value]="rowData" />
      </td>
      <td *ngIf="expandable" class="text-center" style="width: 1rem">
        <button
          type="button"
          pButton
          pRipple
          [pRowToggler]="rowData"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          (click)="rowExpandedEvent($event, rowData, expanded)"
        ></button>
      </td>
      <ng-container *ngIf="isEdit; else commonBodyTemplate">
        <td *ngFor="let col of columns" [pEditableRow]="rowData">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <ng-container
                *ngTemplateOutlet="
                  bodyInputTemplate;
                  context: { $implicit: rowData, col: col }
                "
              ></ng-container>
            </ng-template>
            <ng-template pTemplate="output">
              <ng-container
                *ngTemplateOutlet="
                  bodyOutputTemplate;
                  context: { $implicit: rowData, col: col }
                "
              ></ng-container>
            </ng-template>
          </p-cellEditor>
        </td>
      </ng-container>

      <ng-template #commonBodyTemplate>
        <ng-container
          *ngTemplateOutlet="
            bodyTemplate;
            context: {
              $implicit: rowData,
              rowIndex: rowIndex,
              columns: columns,
              expanded: expanded
            }
          "
        >
        </ng-container>
      </ng-template>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="rowexpansion"
    let-rowData
    let-rowIndex="rowIndex"
    let-columns
  >
    <tr [attr.rowIndex]="rowIndex" class="no-border no-background">
      <td [colSpan]="(dt.columns?.length ?? 0) + headerDefaultColCount">
        <ng-container
          *ngTemplateOutlet="
            expandedRowTemplate;
            context: {
              $implicit: rowData,
              rowIndex: rowIndex,
              columns: columns
            }
          "
        ></ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="footer"
    let-rowData
    let-rowIndex="rowIndex"
    let-columns
  >
    <ng-container
      *ngTemplateOutlet="
        footerTemplate;
        context: { $implicit: rowData, rowIndex: rowIndex, columns: columns }
      "
    ></ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length + headerDefaultColCount">
        {{ "Common.Table.NoData" | translate }}
      </td>
    </tr>
  </ng-template>
</p-table>
